const parsePadding = (paddingStr) => { 
  const values = paddingStr?.split("|"); 

  if (!values) return {};

  return { 
    paddingTop: values[0] || "inherit",
    paddingBottom: values[1] ? values[1] : values[0]
  };
};

export default parsePadding;